export default __webpack_public_path__ + "static/modal02_02-860ae49203e167a262c2e1019a7c5484.jpg";